// Codekit -->

// Global -->
// @codekit-prepend "global/vars.js"

// Utilities -->
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/load-in.js"
// @codekit-prepend "utilities/hero-images.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/image-viewer.js"
// @codekit-prepend "utilities/scroll.js"
// @codekit-prepend "utilities/full-height.js"
// @codekit-prepend "utilities/full-height-minus-header.js"

// Components -->
// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/header-scroll.js"
// @codekit-prepend "components/review-slider.js"
// @codekit-prepend "components/project-gallery.js"
// @codekit-prepend "components/ticker.js"
// @codekit-prepend "components/access-overlay.js"
// @codekit-prepend "components/mtt-overlay.js"
// @codekit-prepend "components/acf-map.js"
// @codekit-prepend "components/video-overlay.js"
// @codekit-prepend "components/scroll-buttons.js"
// @codekit-prepend "components/newsletter.js"
// @codekit-prepend "components/newsletter-trigger.js"

// Resize -->
// @codekit-append "global/document-ready.js"
// @codekit-append "global/resize.js"

//<- Codekit

//Funcitons start -->

//load in
loadIn();

//Menu
menu();

//Header
if (typeof header != "undefined" && header != null) {
    window.addEventListener("scroll", debounce(headerScrollMob));
}
if (typeof homeScroll != "undefined" && homeScroll != null) {
    window.addEventListener("scroll", debounce(headerHomeScroll));
}

if (typeof darkThemeScroll != "undefined" && darkThemeScroll != null) {
    window.addEventListener("scroll", debounce(darkScroll));
}

//Example function pullin
// if (typeof hero != "undefined" && hero != null) {
//     heroSize();
// }

if (typeof fullHeightEls != "undefined" && fullHeightEls != null) {
    makeFullHeight();
}

if (typeof fullHeightMinusHeaderEls != "undefined" && fullHeightMinusHeaderEls != null) {
    makeFullHeightMinusHeader()
}

//<-- Funcitons end
